export default __webpack_public_path__ + "static/media/cvod-16.b6fb5a14.svg";